import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetResponse } from '../..';
import { ClientService } from '../../client.service';
import { ReplaceGatewayFormData } from '@store';

@Injectable()
export class GatewayUpdateApi {
  private readonly baseUrl = 'iot/v1/equipment/installations';

  constructor(private clientService: ClientService) {}

  /**
   * start installation process
   * @param installationId
   * @param gatewaySerial
   */
  startUpdateFirmwareProcess(
    installationId: number,
    gatewaySerial: string
  ): Observable<GetResponse<string>> {
    const endpoint = `${this.baseUrl}/${installationId}/gateways/${gatewaySerial}/update/retry`;

    return this.clientService.post(endpoint, {});
  }

  replaceGateway(replaceGatewaydata: ReplaceGatewayFormData): Observable<GetResponse<string>> {
    const endpoint = `v1.0/gateways/exchange`;

    return this.clientService.post(endpoint, replaceGatewaydata);
  }
}
